import {
  getPublishedEpisodes as repoGetPublishedEpisodes,
  hasPublishedEpisodes as repoHasPublishedEpisodes,
} from 'shared/data/episodeRepository';
import type { PublishedEpisode } from 'shared/data/episodes';

export function getEpisodeByNumber(episodeNumber: string): PublishedEpisode | undefined {
  return repoGetPublishedEpisodes().find((episode) => episode.number === episodeNumber);
}

export function getEpisodesByNumbers(episodeNumbers: string[]): PublishedEpisode[] {
  return episodeNumbers
    .map((number) => getEpisodeByNumber(number))
    .filter((episode): episode is PublishedEpisode => episode !== undefined);
}

export function getRandomEpisodes(count: number, excludeEpisodeNumber: string): PublishedEpisode[] {
  const candidates = repoGetPublishedEpisodes().filter(
    (episode) => episode.number !== excludeEpisodeNumber,
  );
  const shuffled = [...candidates].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

export const getPublishedEpisodes = (): PublishedEpisode[] => repoGetPublishedEpisodes();

export const hasPublishedEpisodes = (): boolean => repoHasPublishedEpisodes();
